import React, { useEffect, useState } from "react";
import { Modal, Form, Select, Input, Button, message } from "antd";
import { CommonDropdownParams } from "../../../constants/CommonDropdownParams";
import { DropdownsResponse } from "../../../models/ICommon";
import { CommonService } from "../../../services/Common/CommonService";

const { TextArea } = Input;

interface StatusModalProps {
	open: boolean;
	currentStatus: string;
	onCancel: () => void;
	onSave: (values: any) => void;
}

const StatusUpdateModal: React.FC<StatusModalProps> = ({ open, currentStatus, onCancel, onSave }) => {
	const [form] = Form.useForm();
	const [loading, setLoading] = useState<boolean>(false);
	const [dropdowns, setDropdowns] = useState<DropdownsResponse>({});
	useEffect(() => {
		getCommonDropdown([CommonDropdownParams.ProfileStatus]);
	}, []);

	const getCommonDropdown = (ids: number[]) => {
		setLoading(true);
		CommonService.getAllDropdowns(ids)
			.then((rawData) => {
				setDropdowns(rawData);
			})
			.catch((error) => {
				message.error("Failed to load dropdowns");
			})
			.finally(() => setLoading(false));
	};
	const handleSave = async () => {
		const values = await form.validateFields();
		onSave(values);
		form.resetFields();
	};

	return (
		<Modal
			open={open}
			title={`Status (Current Status: ${currentStatus})`}
			onCancel={onCancel}
			footer={[
				<Button key="cancel" onClick={onCancel}>
					Cancel
				</Button>,
				<Button key="save" type="primary" onClick={handleSave}>
					Save
				</Button>
			]}
		>
			<Form form={form} layout="vertical" requiredMark>
				<Form.Item label="Status" name="status" rules={[{ required: true, message: "Please select status" }]}>
					<Select
						placeholder="Select status"
						showSearch
						optionFilterProp="label"
						filterSort={(optionA, optionB) =>
							(optionA.label as string)?.toLowerCase().localeCompare((optionB.label as string)?.toLowerCase())
						}
						options={dropdowns?.ApprovalStatus?.map((item) => ({
							value: item.id,
							label: item.label
						}))}
					></Select>
				</Form.Item>

				<Form.Item label="Comment" name="comment" rules={[{ required: true, message: "Please enter comment" }]}>
					<TextArea rows={6} placeholder="Please enter comment" maxLength={500} showCount />
				</Form.Item>
			</Form>
		</Modal>
	);
};

export default StatusUpdateModal;
